<template>
  <div class="base-page">
    <div style="margin-bottom: 10px" class="df both-side">
      <a-space v-if="isDeptLeader">
        <a-select
          v-model:value="requestPayload.demander"
          show-search
          placeholder="需求人"
          style="width: 200px"
          :options="staffList"
          @change="handleSearch"
          allowClear
        >
        </a-select>

        <a-select
          v-model:value="requestPayload.executor"
          show-search
          placeholder="执行人"
          style="width: 200px"
          :options="staffList"
          @change="handleSearch"
          allowClear
        >
        </a-select>

        <a-select
          placeholder="推送"
          v-model:value="requestPayload.isPush"
          @change="handleSearch"
          allowClear
        >
          <a-select-option :value="true">是</a-select-option>
          <a-select-option :value="false">否</a-select-option>
        </a-select>

        <a-select
          placeholder="需求交付确认"
          v-model:value="requestPayload.requirementDeliveryConfirmation"
          @change="handleSearch"
          allowClear
        >
          <a-select-option value="确认">确认</a-select-option>
          <a-select-option value="进行中">进行中</a-select-option>
          <a-select-option value="退回">退回</a-select-option>
        </a-select>
      </a-space>

      <div v-else></div>

      <a-button @click="handleInsertRequirement(null)">新增</a-button>
    </div>

    <div style="height: calc(100vh - 220px)">
      <a-table
        :data-source="table.data"
        bordered
        :pagination="false"
        :columns="columns"
        rowKey="id"
        :scroll="{ y: 'calc(100vh - 340px)', x: 'calc(100vw - 300px)' }"
        :rowClassName="setClassName"
      >
        <template #proposedTime="{ record }">
          {{ timeStampToTime(record.proposedTime, "upload") }}
        </template>

        <template #isPush="{ record }">
          {{ record.isPush ? "已推送" : "未推送" }}
          <!-- <a-button
            size="small"
            @click="handlePush(record)"
            :disabled="pushAuthority(record)"
            >推送</a-button
          > -->
        </template>

        <template #requirementFile="{ record }">
          <echo-file :file="record.requirementFile"></echo-file>
        </template>

        <template #deliveryFile="{ record }">
          <echo-file :file="record.deliveryFile"></echo-file>
        </template>

        <template #isReceive="{ record }">
          <div v-if="record.isReceive !== null">
            {{ record.isReceive ? "已接收" : "拒绝接收" }}
          </div>
        </template>

        <template #progress="{ record }">
          <a-tooltip placement="top" color="#fff">
            <template #title>
              <timeLine :timeLine="record.progress"></timeLine>
            </template>
            <a-tag :color="setTagColor(STATUS[record.status], record)">
              {{ STATUS[record.status] }}

              <img src="@/assets/img/page/touch.png" class="touch-img" />
            </a-tag>
          </a-tooltip>
        </template>

        <template #isDelivery="{ record }">
          {{ record.isDelivery ? "已交付" : "未交付" }}
        </template>

        <template #action="{ record }">
          <a-dropdown>
            <template #overlay>
              <a-menu @click="handleAction($event, record)">
                <template v-if="cutomAuthority(record)">
                  <a-menu-item
                    key="deliveryconfirmation"
                    v-if="record.status === 4"
                    >交付确认</a-menu-item
                  >
                  <a-menu-item
                    key="examine"
                    v-if="
                      record.status === 0 && cutomDepartmentAuthority(record)
                    "
                    >审核</a-menu-item
                  >
                  <a-menu-item key="update" v-if="record.status !== 5"
                    >更新</a-menu-item
                  >
                  <a-menu-item key="delete">删除</a-menu-item>
                </template>

                <template
                  v-if="isCompleteDeptLeader(record) && record.status === 1"
                >
                  <a-menu-item key="receive">接收需求</a-menu-item>
                </template>

                <template v-if="isExecutor(record) && record.status === 3">
                  <a-menu-item key="deliver">需求交付</a-menu-item>
                </template>
                <template
                  v-if="isCompleteDeptLeader(record) && record.status === 2"
                >
                  <a-menu-item key="changeExcutor">选择执行人</a-menu-item>
                </template>
                <template v-if="isExecutor(record) && record.status === 2">
                  <a-menu-item key="changeExcutor">更换执行人</a-menu-item>
                </template>
              </a-menu>
            </template>
            <a-button size="small" type="primary">
              操作
              <DownOutlined />
            </a-button>
          </a-dropdown>
        </template>
      </a-table>
    </div>

    <div class="df both-side">
      <div></div>
      <a-pagination
        size="small"
        :total="table.total"
        :show-total="(total) => `共 ${total} 条`"
        show-size-changer
        show-quick-jumper
        v-model:current="table.pageNum"
        v-model:lineNum="table.lineNum"
        @change="hanldeUpdatePageNum"
        @showSizeChange="hanldeUpdatePageNum"
      />
    </div>
  </div>

  <requirement-form ref="requirementFormRef" @updateTable="updateTable">
  </requirement-form>
</template>

<script>
import { computed, defineComponent, nextTick, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import {
  getTransDeptRequirementList,
  deleteTransDeptRequirement,
  saveTransDeptRequirement,
} from "@/request/view/transDept";
import { DownOutlined } from "@ant-design/icons-vue";
import { useTable } from "@/views/notice/serve/table";
import { showModal } from "@/views/repairprogress/serve/modal";
import { Toast, timeStampToTime, debounce } from "@/utils";
import {
  getStaffListData,
  staffList,
} from "@/views/rdmanagement/components/projectScheme/staffUser";

import {
  getNextProgress,
  getProgressIndex,
  findDepartMentLeader,
  getStatusIndexByName,
  completionTimeLine,
  STATUS,
} from "@/views/departmentalRequirements/serve";

import { sendMessage } from "@/views/departmentalRequirements/socketToast";

import requirementForm from "@/views/departmentalRequirements/form.vue";
import echoFile from "@/views/rdmanagement/components/file";
import timeLine from "@/views/departmentalRequirements/components/timeLine.vue";

export default defineComponent({
  components: {
    echoFile,
    requirementForm,
    timeLine,
    DownOutlined,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();

    const store = useStore();

    const setTagColor = (name, record) => {
      // if (name === '')
      if (record.isReceive !== null && record.isReceive === false) {
        return "#f50";
      }

      if (record.requirementDeliveryConfirmation === "退回") {
        return "#f50";
      }

      if (name === "完成") {
        return "#87d068";
      }

      return "#108ee9";
    };

    const user = store.state.user.user;

    const isDepartmentLeader = user.isDL;

    const requirementFormRef = ref();

    const {
      requestConfig,
      table,
      requestPayload,
      initPayload,
      getListData,
      hanldeUpdatePageNum,
      searchData,
      deleteRecords,
    } = useTable();

    initPayload({
      demander: null,
      executor: null,
      firstLevelDepartment: user.firstLevelDepartment,
      isPush: null,
      lineNum: null,
      pageNum: null,
      requirementDeliveryConfirmation: null,
    });

    /**
     * 发起推送权限
     * */
    const pushAuthority = (record) => {
      return record.demander === user.nickName;
    };

    /**
     * 客户端的操作权限
     * 发起人和部门负责人
     */
    const cutomAuthority = (record) => {
      const leader = findDepartMentLeader(record.demanderDept);

      let isLeader = false;
      if (leader) {
        isLeader = leader.nickName === user.nickName;
      }

      const isDemander = record.demander === user.nickName;

      return isLeader || isDemander;
    };

    const cutomDepartmentAuthority = (record) => {
      const leader = findDepartMentLeader(record.demanderDept);

      let isLeader = false;
      if (leader) {
        isLeader = leader.nickName === user.nickName;
      }

      return isLeader;
    };

    /**
     * 服务端的操作权限
     * 完成需求部门和接收人
     */
    const isExecutor = (record) => {
      let isExecutor = false;

      if (record.executor) {
        isExecutor = record.executor === user.nickName;
      }

      return isExecutor;
    };

    const isCompleteDeptLeader = (record) => {
      if (!record.completeRequirementDept) return false;
      const leader = findDepartMentLeader(record.completeRequirementDept);

      let isCompleteDeptLeader = false;

      if (leader) {
        isCompleteDeptLeader = leader.nickName === user.nickName;
      }

      return isCompleteDeptLeader;
    };

    const isDeptLeader = computed(() => {
      return user.isDL;
    });

    let ifSetCustomColoums = false;

    // const getColoums = () => {
    //   if (ifSetCustomColoums) return;
    //   const domList = Array.from(
    //     document.getElementsByClassName("ant-table-header-column")
    //   ).slice(1, 8);

    //   domList.forEach((item, index) => {
    //     const text = item.childNodes[0].childNodes[0].innerText;

    //     const div = document.createElement("div");
    //     div.innerText = text;
    //     div.className = "custom-columns";

    //     if (index !== 6) {
    //       item.parentNode.style.borderRight = "none";
    //     }
    //     item.parentNode.style.padding = "56px 0 0 0";

    //     if (index === 6) {
    //       div.className = "custom-columns un-boder-right";
    //     }

    //     item.parentNode.appendChild(div);
    //     item.parentNode.removeChild(item);
    //   });

    //   ifSetCustomColoums = true;
    // };

    const serveCustomColor = () => {
      return {
        style: {
          backgroundColor: "#108ee9",
          color: "#fff",
        },
      };
    };

    const getColoums = () => {
      const domList = Array.from(
        document.getElementsByClassName("ant-table-header-column")
      ).slice(1, 8);

      domList.forEach((item, index) => {
        const text = item.childNodes[0].childNodes[0].innerText;

        const div = document.createElement("div");
        div.innerText = text;
        div.className = "custom-columns";

        if (index !== 6) {
          item.parentNode.style.borderRight = "none";
        }
        item.parentNode.style.padding = "56px 0 0 0";

        if (index === 6) {
          div.className = "custom-columns un-boder-right";
        }

        item.parentNode.appendChild(div);
        item.parentNode.removeChild(item);
      });
    };

    const columns = [
      {
        title: "需求端",
        fixed: "left",
        children: [
          {
            title: "序号",
            dataIndex: "customId",
            align: "center",
            width: "80px",
            fixed: "left",
          },
          {
            title: "提出时间",
            align: "center",
            slots: {
              customRender: "proposedTime",
            },
            width: "100px",
            fixed: "left",
          },
          {
            title: "需求名称",
            dataIndex: "requirementName",
            align: "center",
            width: "140px",
            fixed: "left",
          },
          {
            title: "需求内容",
            dataIndex: "requirementContent",
            align: "center",
            width: "200px",
            fixed: "left",
          },
          {
            title: "完成需求部门",
            dataIndex: "completeRequirementDept",
            align: "center",
            width: "140px",
          },
        ],
      },
      {
        title: "需求人",
        dataIndex: "demander",
        align: "center",
        width: "100px",
      },
      {
        title: "期望交付日期",
        dataIndex: "expectedDeliveryDate",
        align: "center",
        width: "130px",
      },
      {
        title: "期望时长",
        dataIndex: "expectedDuration",
        width: "100px",
        align: "center",
      },
      {
        title: "进度",
        slots: {
          customRender: "progress",
        },
        align: "center",
        width: "130px",
      },
      {
        title: "需求文件",
        align: "center",
        width: "100px",
        slots: {
          customRender: "requirementFile",
        },
      },
      {
        title: "推送",
        // dataIndex: "isPush",
        slots: {
          customRender: "isPush",
        },
        align: "center",
        width: "100px",
      },
      {
        title: "交付确认",
        dataIndex: "requirementDeliveryConfirmation",
        align: "center",
        width: "100px",
      },
      {
        title: "服务端",
        customHeaderCell: serveCustomColor,
        children: [
          {
            title: "接收人",
            dataIndex: "executor",
            align: "center",
            width: "100px",
            customHeaderCell: serveCustomColor,
          },
          {
            title: "是否接收",
            slots: {
              customRender: "isReceive",
            },
            align: "center",
            width: "100px",
            customHeaderCell: serveCustomColor,
          },
          {
            title: "交付日期",
            dataIndex: "deliveryDate",
            align: "center",
            width: "130px",
            customHeaderCell: serveCustomColor,
          },
          {
            title: "交付文件",
            align: "center",
            width: "100px",
            customHeaderCell: serveCustomColor,
            slots: {
              customRender: "deliveryFile",
            },
          },
          {
            title: "是否交付",
            slots: {
              customRender: "isDelivery",
            },
            align: "center",
            width: "100px",
            customHeaderCell: serveCustomColor,
          },
          {
            title: "实际时长",
            dataIndex: "actualDuration",
            width: "100px",
            align: "center",
            customHeaderCell: serveCustomColor,
          },
        ],
      },
      {
        title: "操作",
        align: "center",
        slots: {
          customRender: "action",
        },
        width: "100px",
        fixed: "right",
      },
    ];

    requestConfig.pull_fn = getTransDeptRequirementList;
    requestConfig.delete_fn = deleteTransDeptRequirement;

    const handleInsertRequirement = (record) => {
      requirementFormRef.value.showModal({
        type: "insert",
        title: "新增跨部门需求",
      });
    };

    const handleProjectDetails = (record) => {};

    const getDiffrentsDay = (start, end) => {
      const startDate = new Date(start);
      const endDate = new Date(end);
      const timeDiff = Math.abs(endDate - startDate);
      const days = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
      return days;
    };
    const getData = () => {
      getListData()
        .then(() => {
          table.data.forEach((item, index) => {
            item.customId = index + 1 + (table.pageNum - 1) * table.lineNum;
            const { expectedDeliveryDate, pushDate, deliveryDate, progress } =
              item;
            item.status = getStatusIndexByName(progress);
            // 期望时长
            if (expectedDeliveryDate && pushDate) {
              item.expectedDuration = `${getDiffrentsDay(
                pushDate,
                expectedDeliveryDate
              )}天`;
            }
            // 实际时长
            if (deliveryDate && pushDate) {
              item.actualDuration = `${getDiffrentsDay(
                pushDate,
                deliveryDate
              )} 天`;
            }
            item.progress = completionTimeLine(item.progress);
          });
        })
        .then(() => {
          getColoums();
        });
    };

    if (staffList.value.length === 0) {
      getStaffListData();
    }

    const handleAction = (e, record) => {
      const type = e.key;

      let title = "";

      console.log(type, record);
      switch (type) {
        case "update":
          title = "更新跨部门需求";
          requirementFormRef.value.showModal({
            title,
            type,
            data: record,
          });
          break;
        case "examine":
          title = "审核跨部门需求";
          requirementFormRef.value.showModal({
            title,
            type,
            data: record,
          });
          break;
        case "delete":
          deleteRecords([record.id], { title: "确认删除？" }).then((res) => {
            getData();
          });
          break;
        case "receive":
          title = "接收跨部门需求";
          requirementFormRef.value.showModal({
            title,
            type,
            data: record,
          });
          break;
        case "deliver":
          title = "需求交付";
          requirementFormRef.value.showModal({
            title,
            type,
            data: record,
          });
        case "deliveryconfirmation":
          title = "需求交付确认";
          requirementFormRef.value.showModal({
            title,
            type,
            data: record,
          });
        case "changeExcutor":
          title = "更换执行人";
          requirementFormRef.value.showModal({
            title,
            type,
            data: record,
          });
        default:
          break;
      }
    };

    // 发起审核
    const handlePush = (record) => {
      showModal({
        title: "提示",
        toastText: "确认提交给部门负责人审核？",
        success: () => {
          const progress = getNextProgress(record.progress).name;
          const reqData = JSON.parse(JSON.stringify(record));
          reqData.progress = progress;
          reqData.pushDate = new Date();
          reqData.isPush = true;
          saveTransDeptRequirement(reqData)
            .then((res) => {
              const type = res.code === 200 ? "success" : "warning";
              Toast(type, res.message, 3);
              sendMessage("requirementReview", reqData);
              getData();
            })
            .catch((err) => {
              console.log(err);
            });
        },
      });
    };

    //
    const setClassName = (record, index) => {
      let className = "";

      if (record.requirementDeliveryConfirmation === "退回") {
        className = "table-error";
      } else if (record.progress === "close") {
        className = "table-success";
      }

      return className;
    };

    // 更新表格
    const updateTable = () => {
      table.pageNum = 1;
      getData();
    };

    const handleSearch = debounce(() => {
      updateTable();
    }, 100);

    watch(
      () => router,
      (val) => {
        if (
          route.path !== "/marketdepartmentalrequirements" &&
          route.path !== "/rddepartmentalrequirements" &&
          route.path !== "/saledepartmentalrequirements"
        )
          return;

        if (route.query.demander === undefined && !isDeptLeader.value) {
          requestPayload.demander = user.nickName;
          requestPayload.executor = user.nickName;
        } else {
          requestPayload.demander = route.query.demander;
          requestPayload.executor = route.query.executor;
        }

        getData();
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      STATUS,
      table,
      columns,
      isDeptLeader,
      staffList,
      requestPayload,
      requirementFormRef,
      cutomDepartmentAuthority,
      setTagColor,
      pushAuthority,
      handleSearch,
      isExecutor,
      setClassName,
      isCompleteDeptLeader,
      cutomAuthority,
      getProgressIndex,
      handlePush,
      timeStampToTime,
      updateTable,
      handleAction,
      handleProjectDetails,
      handleInsertRequirement,
      hanldeUpdatePageNum,
    };
  },
});
</script>

<style lang="less" scoped>
.base-page {
  background: #fff;
  width: 100%;
  height: calc(100vh - 120px);
  box-shadow: 0 0 10px 0 #ccc;
  border-radius: 20px;
  padding: 15px;
}

.touch-img {
  width: 15px;
  height: 15px;
  margin-bottom: 3px;
}

:deep(.ant-table-thead > tr > th) {
  padding: 16px 0px;
}

:deep(.ant-table-tbody > tr > td) {
  padding: 10px 4px;
}

:deep(.table-error) td {
  // background-color: #f50;
}

:deep(.table-success) td {
  background-color: #87d068;
}

:deep(.ant-table-bordered .ant-table-thead > tr > th),
:deep(.ant-table-bordered .ant-table-tbody > tr > td) {
  border-right: 1px solid #a9a9a9;
}
:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #a9a9a9;
}
:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #a9a9a9;
}
:deep(.ant-table-bordered .ant-table-thead > tr:not(:last-child) > th) {
  border-bottom: 1px solid #a9a9a9;
}
:deep(
    .ant-table-bordered .ant-table-header > table,
    .ant-table-bordered .ant-table-body > table,
    .ant-table-bordered .ant-table-fixed-left table,
    .ant-table-bordered .ant-table-fixed-right table
  ) {
  border-top: 1px solid #a9a9a9;
}
:deep(.custom-columns) {
  height: 58px;
  border-right: 1px solid #a9a9a9;
  border-top: 1px solid #a9a9a9;
  line-height: 58px;
}
:deep(.un-boder-right) {
  border-right: none;
}
</style>
